import baseApi from ".";
import createQueryFn from "../createQueryFn";
import api from "api";
import { CreateDepartmentRequest, CreateDepartmentResponse } from "api/departments/createDepartment";
import { DeleteDepartmentRequest, DeleteDepartmentResponse } from "api/departments/deleteDepartment";
import { GetAllDepartmentsResponse } from "api/departments/getAll";
import { UpdateDepartmentRequest, UpdateDepartmentResponse } from "api/departments/updateDepartment";

const departmentsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createDepartment: builder.mutation<CreateDepartmentResponse, CreateDepartmentRequest>({
      queryFn: createQueryFn(api.departments.createDepartment),
      invalidatesTags: [{ type: "Department", id: "LIST" }],
    }),
    deleteDepartment: builder.mutation<DeleteDepartmentResponse, DeleteDepartmentRequest>({
      queryFn: createQueryFn(api.departments.deleteDepartment),
      invalidatesTags: [{ type: "Department", id: "LIST" }],
    }),
    getAllDepartments: builder.query<GetAllDepartmentsResponse, void>({
      queryFn: createQueryFn(api.departments.getAllDepartments),
      providesTags: [{ type: "Department", id: "LIST" }],
    }),
    updateDepartment: builder.mutation<UpdateDepartmentResponse, UpdateDepartmentRequest>({
      queryFn: createQueryFn(api.departments.updateDepartment),
      invalidatesTags: [{ type: "Department", id: "LIST" }],
    }),
  }),
});

export const {
  useCreateDepartmentMutation,
  useDeleteDepartmentMutation,
  useGetAllDepartmentsQuery,
  useUpdateDepartmentMutation,
} = departmentsApi;

export default departmentsApi;
